export const formatUsageTime = (responseTimeMs?: number): string | null => {
  if (typeof responseTimeMs !== "number") return null
  const clamped = Math.max(0, responseTimeMs)
  return (Math.round((clamped / 1000) * 10) / 10).toFixed(1)
}

export const formatCredits = (costCredits?: number): string | null => {
  if (typeof costCredits !== "number") return null
  return new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(costCredits)
}

export const summarizeUsageMeta = (params: {
  responseTimeMs?: number
  costCredits?: number
  convId?: number
}): string => {
  const formattedTime = formatUsageTime(params.responseTimeMs)
  const formattedCredits = formatCredits(params.costCredits)

  return [
    typeof params.convId === "number" ? `convId=${params.convId}` : "",
    formattedCredits ? `credits=${formattedCredits}` : "",
    formattedTime ? `time=${formattedTime}s` : "",
  ]
    .filter(Boolean)
    .join("; ")
}
